import {
  scoreRules,
  useGetSecrets,
} from '@internal/backstage-plugin-aws-services';
import { SubvalueCell, Table, TableColumn } from '@backstage/core-components';

const renderHealth = (rowData: any) => {
  if (scoreRules.red.rule(rowData.ChangedSince)) {
    return <scoreRules.red.icon />;
  }

  if (scoreRules.orange.rule(rowData.ChangedSince)) {
    return <scoreRules.orange.icon />;
  }

  if (scoreRules.green.rule(rowData.ChangedSince)) {
    return <scoreRules.green.icon />;
  }

  return <scoreRules.orphaned.icon />;
};

const columns: TableColumn[] = [
  {
    title: 'Name',
    field: 'Name',
  },
  {
    title: 'Account',
    sorting: false,
    render: (row: any): React.ReactNode => (
      <SubvalueCell
        value={row.AccountId}
        subvalue={`${row.AccountName} | ${row.Region}`}
      />
    ),
  },
  {
    title: 'Project',
    field: 'Project',
  },
  {
    title: 'Email',
    field: 'Email',
  },
  {
    title: 'Created Date',
    field: 'CreatedDate',
    type: 'datetime',
  },
  {
    title: 'Last Changed Date',
    field: 'LastChangedDate',
    type: 'datetime',
  },
  {
    title: 'Age',
    field: 'ChangedSince',
    type: 'numeric',
    defaultSort: 'desc',
  },
  {
    title: 'Health',
    render: renderHealth,
    sorting: false,
  },
];

export const OrphanedSecretsTable = () => {
  const { value: secrets, loading } = useGetSecrets({ teams: [] });

  return (
    secrets && (
      <Table
        options={{
          paging: true,
          padding: 'dense',
          sorting: true,
          pageSize: 10,
        }}
        isLoading={loading}
        data={secrets.filter(secret => secret.Team === 'orphaned')}
        columns={columns}
        title="Orphaned Secrets"
      />
    )
  );
};
